@if (imageToCrop(); as imageToCrop) {
<div class="ui-crop">
	<div
		[libFlexRow]="isMobileView()"
		[libFlexRowGap]="'16px'"
		[libFlexRowAlign]="showImagePreview() ? 'center' : 'start'"
	>
		<div libFlexColumn [libFlexSize]="!isMobileView() ? 'fill' : 'full'">
			<image-cropper
				class="ui-image-cropper-elem"
				[alignImage]="'left'"
				[output]="'base64'"
				[imageFile]="imageToCrop"
				[aspectRatio]="aspectRatioCalculated()"
				[maintainAspectRatio]="aspectRatio() !== 'freeform' ? true : false"
				[resizeToWidth]="resizeToWidth() ?? 0"
				[resizeToHeight]="resizeToHeight() ?? 0"
				[format]="'png'"
				(imageCropped)="handleImageCropped($event)"
				(imageLoaded)="imageLoaded()"
				(cropperReady)="cropperReady()"
				(loadImageFailed)="loadImageFailed()"
			>
			</image-cropper>
		</div>
		@if (showImagePreview()) {
		<div libFlexColumn [libFlexSize]="!isMobileView() ? 'fill' : 'full'">
			<div>
				@if (croppedImage(); as croppedImage) {
				<img class="ui-crop-preview" [src]="croppedImage.base64" />
				}
			</div>
		</div>
		}
	</div>

	<div class="push-top" libFlexRow [libFlexRowGap]="'16px'">
		<div libFlexColumn>
			<lib-button [buttonSize]="'default'" [buttonType]="'primaryLight'" (click)="handleCrop()">{{
				cropButtonTitle()
			}}</lib-button>
		</div>

		@if (isUploading()) {

		<div libFlexColumn>
			<lib-loader [loaderType]="'spinner'"></lib-loader>
		</div>
		}
	</div>
</div>
}
